import * as React from 'react'

import LocationIcon from '../assets/location.svg'

// NOT using the <Svg /> component, because want the default "eager" loading.
const LocationSvg = ({ size }: { size: number }) => <img src={LocationIcon} width={size} height={size} />

export default LocationSvg
